import { render, staticRenderFns } from "./Widget1.vue?vue&type=template&id=57b831a8&scoped=true"
import script from "./Widget1.vue?vue&type=script&lang=js"
export * from "./Widget1.vue?vue&type=script&lang=js"
import style0 from "./Widget1.vue?vue&type=style&index=0&id=57b831a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b831a8",
  null
  
)

export default component.exports